import dayjs from "dayjs"
import { convertToRaw } from "draft-js"


class Newsletter {
    constructor(newsletter) {
        const { id, name, images, status, system_area, official_release_date, description, image, content } = newsletter
        this.name = name
        if (id)
            this.id = id
        if (description)
            this.description = description
        if (system_area)
            this.system_area = system_area?.id || system_area
        if (content) {
            let nContent = content.getCurrentContent();
            this.content = JSON.stringify(convertToRaw(nContent));
        }
        if (status)
            this.status = status
        if (images)
            this.images = images
        if (official_release_date)
            this.official_release_date = dayjs(official_release_date).format('YYYY-MM-DD')
        if (image?.file)
            this.image = image.file
    }
}

export default Newsletter